import React, { Component } from "react"
import { Grid } from "@material-ui/core";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Constants from "./Constants";
import ProjectListPage from "./ProjectListPage";
import ProjectPage from "./ProjectPage";
import PageTab from "./PageTab";
import withWindowSize from '../withWindowSize';

import "../../css/Portfolio.css";

const GridOffset = (props) => { return <Grid item></Grid>; }

const about = (<div>
    <div className="about-text">
        <p>
            The content has been migrated to:
            <br/><a href="https://ta-david-yu.github.io/">https://ta-david-yu.github.io/</a>
        </p>
    </div>
</div>);

class Main extends Component {

    constructor(props) {
        super(props);
        
        this.handleOnClickLongTermPageTab = this.handleOnClickLongTermPageTab.bind(this);
        this.handleOnClickExperimentalPageTab = this.handleOnClickExperimentalPageTab.bind(this);
        this.handleOnClickMiscPageTab = this.handleOnClickMiscPageTab.bind(this);
        this.handleOnClickHomeButton = this.handleOnClickHomeButton.bind(this);
        this.handleOnClickOnWorkListItem = this.handleOnClickOnWorkListItem.bind(this);

        const initialPageType = Constants.PageType.ProjectList;
        const initialListName = Constants.ProjectCategory.LongTerm;
        this.state = { 
            currPageType: initialPageType,
            currListName: initialListName,
            currWorkData: ""
        };
    }

    handleOnClickLongTermPageTab()
    {
        this.setState(
            {
                currPageType: Constants.PageType.ProjectList, 
                currListName: Constants.ProjectCategory.LongTerm
            }
        );
    }

    handleOnClickExperimentalPageTab()
    {
        this.setState(
            {
                currPageType: Constants.PageType.ProjectList, 
                currListName: Constants.ProjectCategory.Experimental
            }
        );
    }

    handleOnClickMiscPageTab()
    {
        this.setState(
            {
                currPageType: Constants.PageType.ProjectList, 
                currListName: Constants.ProjectCategory.Art
            }
        );
    }

    handleOnClickHomeButton()
    {
        this.setState(
            {
                currPageType: Constants.PageType.ProjectList
            }
        );
    }

    handleOnClickOnWorkListItem(workData)
    {
        this.setState(
            {
                currPageType: Constants.PageType.Project,
                currWorkData: workData
            }
        );
    }

    render() {
        const currPageType = this.state.currPageType;
        const currListName = this.state.currListName;
        const currWorkData = this.state.currWorkData;

        return (
            <div>
                <div className="top-content">
                    <Grid 
                    container 
                    spacing={8}
                    direction="column"
                    justify="center"
                    alignItems="center">
                        <GridOffset/><GridOffset/><GridOffset/><GridOffset/>
                        <Grid item xs={12}>
                            <img alt="ta-david-yu" src="./img/ta-david-yu-mascot-x64.png" className="logo"/>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="header-text">ta david yu</div>
                        </Grid>
                        <Grid item>
                            <a href="https://twitter.com/TaDavidYu"><img alt="twitter" src="./img/twitter-x26.png" className="icon-26"/></a>
                            <a href="https://github.com/ta-david-yu"><img alt="github" src="./img/github-x26.png" className="icon-26"/></a>
                            <a href="https://www.linkedin.com/in/ta-david-yu/"><img alt="linkedin" src="./img/linkedin-x26.png" className="icon-26"/></a>
                            <a href="mailto: ta.yu.gamedev@gmail.com"><img alt="email" src="./img/gmail-x26.png" className="icon-26"/></a>
                        </Grid>
                        <Grid item lg={6} md={12} sm={12} xs>
                            <div className="center-align">
                                {about}
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <footer>
                    fonts made by <span/>
                    <a className="footer-link" href="https://managore.itch.io/">Daniel Linssen</a>, social icons made by <span/>
                    <a className="footer-link" href="https://kronbits.itch.io/matriax-free-assets">Davit Masia</a>
                </footer>
            </div>
        );
    }
}

export default withWindowSize(Main);